module.exports = __webpack_public_path__ + "static/media/icon_inquiry_heart_like.3d25ad80.svg";